// Top bar: notifications + user + logout. The store toggle now lives inside each module that uses it
// (Orders, Payments, Clients, New order) rather than globally here.
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore.js';
import { useStoreContext } from '../../stores/storeContext.js';
import { LogoutIcon, MenuIcon } from '../icons.jsx';
import NotificationsBell from './NotificationsBell.jsx';

const ROLE_LABEL = { INTERNAL_STAFF: 'Internal staff', REP: 'Wholesale rep', CLIENT: 'Wholesale client' };

function initials(name = '') {
  return name
    .split(' ')
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export default function TopBar({ onMenu }) {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const initForUser = useStoreContext((s) => s.initForUser);

  // Reconcile the active store with the signed-in user's store access.
  useEffect(() => {
    initForUser(user);
  }, [user, initForUser]);

  return (
    <header className="flex h-[57px] min-w-0 shrink-0 items-center gap-4 border-b border-line bg-surface px-4 sm:px-6">
      {/* Phones / small tablets: the sidebar is hidden, this opens it as a slide-out menu. */}
      <button
        type="button"
        onClick={onMenu}
        aria-label="Open menu"
        className="-ml-1 rounded-md p-2 text-text-secondary hover:bg-surface-raised md:hidden"
      >
        <MenuIcon size={22} />
      </button>
      <div className="ml-auto flex items-center gap-3">
        <NotificationsBell />
        <Link
          to="/account"
          title="Your account"
          className="flex items-center gap-3 rounded-md px-1.5 py-1 transition hover:bg-surface-raised focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40"
        >
          <div className="hidden text-right sm:block">
            <div className="text-sm font-medium text-text-primary">{user?.name}</div>
            <div className="font-mono text-xs text-text-muted">{ROLE_LABEL[user?.role] || user?.role}</div>
          </div>
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent text-sm font-medium text-white">
            {initials(user?.name)}
          </span>
        </Link>
        <button
          type="button"
          onClick={logout}
          className="flex items-center gap-2 rounded-md border border-line px-3 py-1.5 text-sm font-medium text-text-secondary transition hover:bg-surface-raised hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40"
        >
          <LogoutIcon size={16} />
          <span className="hidden md:inline">Log out</span>
        </button>
      </div>
    </header>
  );
}
